import React, { useState, useEffect } from "react"
import {
  Card,
  CardBody,
  Col,
  Container,
  Label,
  Row,
  Form,
  FormGroup,
} from "reactstrap"
import Breadcrumbs from "../../components/Common/Breadcrumb"
import { toast, ToastContainer } from "react-toastify"
import { URLS } from "../../Url"
import Select from "react-select"
import axios from "axios"

function ContactUs() {
  const [PaymentMethod, setPaymentMethod] = useState([])
  const [PaymentOptions, setPaymentOptions] = useState([])

  const token = JSON.parse(localStorage.getItem("authUser"))?.token

  ///////////////////////////Get_authUser///////////////////////////////////////////
  var GetAuth = localStorage.getItem("authUser")
  var TokenJson = JSON.parse(GetAuth)
  var TokenData = TokenJson.token

  const [selectedOptions, setSelectedOptions] = useState([])
  const [selectedOptions1, setSelectedOptions1] = useState([])

  const multis = selectedOptions => {
    setSelectedOptions(selectedOptions)
  }

  const multis1 = selectedOptions => {
    setSelectedOptions1(selectedOptions)
  }

  useEffect(() => {
    const fetchPaymentOptions = async () => {
      try {
        const response = await axios.post(
          URLS.GetPaymentOptions,
          {},
          { headers: { Authorization: `Bearer ${token}` } }
        )
        setPaymentOptions(response.data.paymentoptions)
      } catch (error) {
        toast.error("Failed to fetch Payment Options")
      }
    }
    fetchPaymentOptions()
  }, [token])

  useEffect(() => {
    const fetchPaymentMethods = async () => {
      try {
        const response = await axios.post(
          URLS.GetPaymentMethods,
          {},
          { headers: { Authorization: `Bearer ${token}` } }
        )
        setPaymentMethod(response.data.paymentmethods)
      } catch (error) {
        toast.error("Failed to fetch Payment Methods")
      }
    }
    fetchPaymentMethods()
  }, [token])

  useEffect(() => {
    Get()
  }, [])

  const Get = () => {
    var token = TokenData
    axios
      .post(
        URLS.GetContact,
        {},
        {
          headers: { Authorization: `Bearer ${token}` },
        }
      )
      .then(res => {
        setform(res.data.contactus)
      })
  }

  const handleSubmit = e => {
    e.preventDefault()
    EditProduct()
  }

  const EditProduct = () => {
    var token = TokenData
    const dataArray = {
      paymentOption: selectedOptions,
      paymentMethod: selectedOptions1,
    }
    axios
      .put(URLS.UpdateProfile, dataArray, {
        headers: { Authorization: `Bearer ${token}` },
      })
      .then(
        res => {
          if (res.status === 200) {
            toast(res.data.message)
          }
        },
        error => {
          if (error.response && error.response.status === 400) {
            toast(error.response.data.message)
          }
        }
      )
  }

  const paymentoptions = PaymentOptions.map(data => ({
    value: data._id,
    label: data.name,
  }))

  const paymentmethodOption = PaymentMethod.map(data => ({
    value: data._id,
    label: data.name,
  }))

  return (
    <React.Fragment>
      <div className="page-content">
        <Container fluid>
          <Breadcrumbs
            title="Bizzmate Supplier"
            breadcrumbItem="Payments Methods"
          />
          <Form
            onSubmit={e => {
              handleSubmit(e)
            }}
          >
            <Card>
              <CardBody>
                <Row className="d-flex justify-content-center">
                  <Col md="8">
                    <FormGroup className="mb-5 mt-5">
                      <Label>
                        Payment Method
                        <span className="text-danger">*</span>
                      </Label>
                      <Select
                        placeholder="Enter Payment Method Values"
                        options={paymentoptions}
                        value={selectedOptions}
                        isSearchable={true}
                        onChange={multis}
                        isMulti
                      />
                    </FormGroup>
                  </Col>
                  <Col md="8">
                    <FormGroup className="mb-3">
                      <Label>
                        Payment Option
                        <span className="text-danger">*</span>
                      </Label>
                      <Select
                        placeholder="Enter  Payment Option Values"
                        options={paymentmethodOption}
                        value={selectedOptions1}
                        isSearchable={true}
                        onChange={multis1}
                        isMulti
                      />
                    </FormGroup>
                  </Col>
                </Row>
                <Col md={12}>
                  <div className=" mb-2" style={{ float: "right" }}>
                    <button
                      type="submit"
                      style={{ width: "120px" }}
                      className="btn btn-primary m-1"
                    >
                      Update <i className="fas fa-cHCUk-circle"></i>
                    </button>
                  </div>
                </Col>
              </CardBody>
            </Card>
          </Form>
        </Container>
        <ToastContainer />
      </div>
    </React.Fragment>
  )
}

export default ContactUs
